import React, { lazy, useEffect, useRef } from "react";
import { Routes, Route } from "react-router";
import Login from "./pages/Login";
import ScrollToTop from "./components/ScrollToTop";
import AddManager from "./components/AddManager/AddManager";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import ToastContainer from "./components/CustomComponents/Toaster/ToastContainer";

import Notification from "./pages/Notification";
import PageLayout from "./pages/PageLayout";
import NotFound from "./pages/NotFound";
import EmployeeLasttracked from "./components/Employees/EmployeeLasttracked/EmployeeLasttracked";
import MissedScreenshots from "./components/Screenshots/MissedScreenshots";
import { setDate, setFilterChosen } from "./features/date/dashboardSlice";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Screenshots = lazy(() => import("./pages/Screenshots"));
const Roles = lazy(() => import("./pages/roles"));
const ManagerList = lazy(() => import("./pages/ManagerList"));
const Settings = lazy(() => import("./pages/Settings"));
const Reports = lazy(() => import("./pages/Reports"));
const EmployeePerformance = lazy(
  () => import("./pages/EmployeePerformance")
);
const ExployeesLists = lazy(() => import("./pages/ExployeesLists"));
const EmployeeOverview = lazy(() => import("./pages/EmployeeOverview"));

function App() {
  const addManager = useAppSelector((state) => state.addManager);
  const syncState = useAppSelector((state) => state.settingSync);

  const hasCheckedDate = useRef(false);

  const dispatch = useAppDispatch()

  const { startDate, endDate } = useAppSelector((state) => state.filterData);

  useEffect(() => {
    if (hasCheckedDate.current || !startDate || !endDate) return;

    hasCheckedDate.current = true;

    const savedDate = new Date(startDate);
    const today = new Date();

    const isSameDay =
      savedDate.getFullYear() === today.getFullYear() &&
      savedDate.getMonth() === today.getMonth() &&
      savedDate.getDate() === today.getDate();

    if (!isSameDay) {
      dispatch(
        setDate({ startDate: today || today, endDate: today || today })
      );
      dispatch(setFilterChosen("today"));
    }
  }, [startDate, endDate, dispatch]);

  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<PageLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/screenshots" element={<Screenshots />} />

          <Route
            path="/missedscreenshots"
            element={<MissedScreenshots />}
          />

          <Route path="/roles" element={<Roles />} />

          <Route path="/managerList" element={<ManagerList />} />

          <Route path="/addroles" element={<Roles />} />

          <Route path="/editroles" element={<Roles />} />

          <Route path="/viewroles" element={<Roles />} />

          <Route path="/settings" element={<Settings />} />

          <Route path="/reports" element={<Reports />} />

          <Route
            path="/employeePerformance"
            element={<EmployeePerformance />}
          />

          <Route
            path="/employeelist"
            element={<ExployeesLists />}
          />

          <Route
            path="/employeeLasttracked"
            element={<EmployeeLasttracked />}
          />

          <Route path="/notification" element={<Notification />} />

          <Route
            path="/employeeOverview"
            element={<EmployeeOverview />}
          />

          {/* Catch-all 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>

      {addManager?.modalShow && <AddManager />}

      {syncState?.isSync && (
        <div className="loader-container">
          <img
            src="/images/loader/content_loader.gif"
            className="image-loader-container"
            alt="Loading"
          />
        </div>
      )}

      <ToastContainer />
    </>
  );
}

export default App;